<template>
    <div class="profile-avatar">
        <div class="avatar-wrap" @click="openUpload">
            <div class="avatar-img" :style="{ width: `${size}px`, height: `${size}px` }">
                <v-img v-if="img" :src="img" eager cover />
                <span v-else class="avatar-initials" :style="{ fontSize: `${Math.round(size * 0.33)}px` }">
                    {{ initials }}
                </span>
            </div>
            <button-tooltip icon top :tooltip="$t('common.change_photo')" buttonClass="avatar-edit" @click="openUpload">
                <v-icon size="16" color="txtSecondary">$edit</v-icon>
            </button-tooltip>
        </div>

        <template v-if="showName">
            <div class="avatar-name">{{ name }}</div>
            <div v-if="subtitle" class="avatar-subtitle">{{ subtitle }}</div>
        </template>

        <upload-avatar-dialog ref="upload" />
    </div>
</template>

<script>
import UploadAvatarDialog from '@/components/student/UploadAvatarDialog'
import ButtonTooltip from '@/components/common/ButtonTooltip'
import { getInitials } from "@/utils/Common";

export default {
    name: "ProfileAvatar",
    components: { UploadAvatarDialog, ButtonTooltip },
    props: {
        img: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        showName: {
            type: Boolean,
            default: false,
        },
        size: {
            type: [Number, String],
            default: 110,
        }
    },
    computed: {
        initials(vm = this) {
            return getInitials(vm.name) || '-'
        }
    },
    methods: {
        openUpload() {
            const vm = this
            vm.$refs.upload.show()
        }
    }
}
</script>

<style scoped>
.profile-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.avatar-wrap {
    position: relative;
    margin-bottom: 16px;
    cursor: pointer;
}

.avatar-img {
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid var(--v-surface-base);
    box-shadow: 0 0 0 3px var(--v-accent-base);
    background: linear-gradient(135deg, #CCFF33, #339999);
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-initials {
    font-weight: 800;
    color: #0C0E12;
}

.profile-avatar >>> .avatar-edit {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 34px !important;
    height: 34px !important;
    border-radius: 50% !important;
    background: var(--v-surface-base) !important;
    border: 2px solid var(--v-outline-base) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.avatar-name {
    font-size: 22px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    margin-bottom: 4px;
    text-align: center;
}

.avatar-subtitle {
    font-size: 13px;
    color: var(--v-txtSecondary-base);
    margin-bottom: 14px;
    text-align: center;
}
</style>
